import VisiMisiContent from "../../components/layouts/tentang/VisiMisiContent";

import React from "react";

const VisiMisi: React.FC = () => {
  return (
    <div>
      <VisiMisiContent />
    </div>
  );
};

export default VisiMisi;
